import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { getDeliveryApi, getOrderPreparedApi, getOrdersListApi, getUserInfoApi } from '../../../Api/PanelAdminServices'
import OrderListOfOneRestaurant from '../../Modal/Information/OrderListOfOneRestaurant/OrderListOfOneRestaurant'
import SelectDelivery from '../../Modal/Information/SelectDelivery/SelectDelivery'
import UserInfo from '../../Modal/Information/UserInfo/UserInfo'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import OrderPreparedTable from '../../Tables/OrderPart/OrderPreparedTable/OrderPreparedTable'
import { errorToast } from '../../../Utils/Toast/Toast'
const OrdersPreparedContainer = () => {
  const[prepared,setPrepared]=useState([])
  const[cityID,setCityID]=useState([])
  const[orderID,setOrderID]=useState([])
  const[Info,setInfo]=useState([])
  const[orderDetail,setOrderDetail]=useState([])
  const[address,setAddress]=useState()

  useEffect(() => {
    getOrderPrepared()
  }, [])

  const getOrderPrepared=async()=>{
    getOrderPreparedApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setPrepared(res.orders)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }

  const data =prepared&&prepared.map((item,index)=>{
    return({
      key:index, 
      person: item.first_name + ' ' + item.last_name,
      city: item.city, 
      orderNumber:item.id,
      date:item.date,
      shopName: item.supplier_name,
      cityId:item.city_id,
      userId:item.user_id,
      address:item.address,
      supplierId:item.supplier_id
    }) 
  })
  const [isModalVisible, setIsModalVisible] = useState(false)
  const showModal = async(info) => {
    const result = await getUserInfoApi(info.userId)
    setInfo(result.info)
    setAddress(info.address)
    setIsModalVisible(true);
  }
  const handleOk = () => {
    setIsModalVisible(false);
  }
  const [isOrderVisible, setIsOrderVisible] = useState(false)
  const [delivery, setDelivery] = useState(false)
  const showOrder =async (info) => {
    getOrdersListApi(info.orderNumber,info.supplierId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setOrderDetail(res.orders)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
    setIsOrderVisible(true)
  }
  const handleOkOrder = () => {
    setIsOrderVisible(false)
  }
  const handleOkDelivery = () => {
    setDelivery(false)
  }
  const showdelivery=async(info)=>{
    setDelivery(true)
    getDeliveryApi(info.cityId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setCityID(res.delivery)
          setOrderID(info.orderNumber)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  return (
    <div>
      <Modal width={350} title="اطلاعات شخص" open={isModalVisible} onOk={handleOk} footer={null}>
        <UserInfo address={address} Info={Info} handleOk={handleOk}/>
      </Modal>
      <Modal width={350} title="لیست سفارش" open={isOrderVisible} onOk={handleOkOrder} footer={null}>
        <OrderListOfOneRestaurant orderDetail={orderDetail} handleOk={handleOkOrder}/>
      </Modal>
      <Modal width={350} title="اسامی پیک" open={delivery} onOk={handleOkDelivery} footer={null}>
        <SelectDelivery orderID={orderID} cityID={cityID} handleOk={handleOkDelivery}/>
      </Modal>
      <TableFixedPage title={"سفارشات آماده شده"} />
      <OrderPreparedTable showdelivery={showdelivery} showModal={showModal} showOrder={showOrder} data={data}/>
    </div>
  )
}
export default OrdersPreparedContainer